

import request, { get, post, put, remove } from '@/utils/request'

// 获取文件列表
export const getCcfileDownloadUrl = (params: any[]) => {
  return post<any>(`/cmp-doc/download/query_download_url`, params)
}
// 使用示例：
// getCcfileDownloadUrl([{
//   "fileName": "",
//   "fileKey": ""
// }])
// 响应：[
// 	{
// 		"fileKey": "",
// 		"fileMd5": "",
// 		"fileSize": 0,
// 		"downloadUrls": []
// 	}
// ]